import React from 'react';
import { useTranslation } from 'react-i18next';

type TProps = {
  amount?: number;
};

const TabAmount: React.FC<TProps> | null = ({ amount }) => {
  const { t } = useTranslation();

  return amount !== undefined ? (
    <>{t('tabAmount', { amount: amount.toLocaleString() })}</>
  ) : null;
};

export default React.memo(TabAmount);
